import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { borderRadius, cardDimensionsMedia, palette, spaces } from '../../../assets/styles/themes/tokens';
import { useTranslation } from 'react-i18next';
import { CourseCoverPageContext } from './CourseCoverPageProvider';
import useScreenSize from '../../../utils/useScreenSize';
import CurvedArrow from '../../../assets/course/curvedArrow.svg';
import CourseCoverButton from './CourseCoverButton';
import placeholderImage from '../../../assets/course/certificate.png';

const CourseCoverPageCertificatesBanner = () => {
  const { t } = useTranslation();
  const { isSmallScreen, isLargeScreen } = useScreenSize();
  const { isLoading } = useContext(CourseCoverPageContext);

  if (isLoading) return <></>;

  return <Box sx={{
    width: '100%',
    padding: spaces.lg,
    maxWidth: cardDimensionsMedia.desktop.maxWidth,
    backgroundColor: palette.primary.contrastText,
    borderRadius: borderRadius.lg,
    position: 'relative',
    display: 'flex',
    gap: spaces.md,
    flexDirection: isSmallScreen ? 'column' : 'row',
    alignItems: 'center'
  }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection:'column',
        gap: spaces.lg,
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: spaces.xs,
          maxWidth: isLargeScreen ? 540 : undefined
        }}>
        <Typography variant='h6' sx={{ color: palette.secondary.main }}>
          {t('Receive a certificate')}
        </Typography>
        <Typography variant='body2' sx={{ color: palette.secondary.main }}>
          {t('Add this qualification to your LinkedIn profile, resume or CV.')}
        </Typography>
      </Box>
      <CourseCoverButton coverPageSection='certificate' />
    </Box>
    <Box
      sx={{
        position: isLargeScreen ? 'absolute' : 'relative',
        right: isLargeScreen ? 60 : 0,
        bottom: isLargeScreen ? 27 : 0,
        paddingLeft: '76px',
        paddingBottom: isSmallScreen ? '22px' : 0,
        width: 'fit-content'
      }}>
      <Box 
        component={CurvedArrow} 
        sx={{ 
          color: palette.primary.main, 
          width: 176, 
          height: 79,
          position: 'absolute',
          bottom: isSmallScreen ? `-${spaces.xs}` : `-${spaces.xl}`,
          left: 0
        }}/>
      <Box
        component='img'
        src={placeholderImage}
        sx={{
          height: 175,
          width: 221, 
          background: palette.background.paperElevation2,
          borderRadius: borderRadius.md,
        }}
      />
    </Box>
  </Box>;
};

export default CourseCoverPageCertificatesBanner;
